import { render } from "./NexusPay.vue?vue&type=template&id=01eb0336"
import script from "./NexusPay.vue?vue&type=script&lang=js"
export * from "./NexusPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__